import React from 'react';

import { useTranslation } from 'react-i18next';

import { Avatar, type AvatarProps, AvatarSize } from '@pkg/components';
import { useMediaQuery } from '@pkg/providers';
import { abbreviateNumber } from '@pkg/utils';

import { type StatsCardAvatarSize } from './types';

import { AvatarWrapper, Card, Item, ItemLabel, ItemValue, List, StatsCardWrapper, Title } from './styles';

export interface StatsCardProps {
    title?: string;
    // TODO: Support `videoUrl`.
    image?: AvatarProps['imageUrl'];
    imageLabel?: AvatarProps['title'];
    imageSize?: StatsCardAvatarSize;
    membersCount?: number;
    assetsCount?: number;
    followersCount?: number;
}

export function StatsCard({
    title,
    image,
    imageLabel,
    imageSize = AvatarSize.Medium,
    membersCount = 0,
    assetsCount = 0,
    followersCount = 0,
}: StatsCardProps) {
    const { t: translate } = useTranslation('statsCard');
    const { tablet } = useMediaQuery();

    const cardSizeLarge = tablet && imageSize === AvatarSize.Larger;

    return (
        <StatsCardWrapper $large={cardSizeLarge}>
            <AvatarWrapper $size={imageSize}>
                <Avatar imageUrl={image} title={imageLabel} size={imageSize} />
            </AvatarWrapper>

            <Card>
                <Title $large={cardSizeLarge}>{title}</Title>

                <List>
                    <Item>
                        <ItemValue $large={cardSizeLarge}>{abbreviateNumber(membersCount)}</ItemValue>
                        <ItemLabel $large={cardSizeLarge}>{translate('label_members')}</ItemLabel>
                    </Item>

                    <Item>
                        <ItemValue $large={cardSizeLarge}>{abbreviateNumber(assetsCount)}</ItemValue>
                        <ItemLabel $large={cardSizeLarge}>{translate('label_assets')}</ItemLabel>
                    </Item>

                    <Item>
                        <ItemValue $large={cardSizeLarge}>{abbreviateNumber(followersCount)}</ItemValue>
                        <ItemLabel $large={cardSizeLarge}>{translate('label_followers')}</ItemLabel>
                    </Item>
                </List>
            </Card>
        </StatsCardWrapper>
    );
}
